<div class="entete">
  <h1 [ngStyle]="{'color':'#47BB9C'}">En cours de construction</h1>
</div>
<div class="corps">
  <h1> Cette page n'existe pas encore, elle est en cours de construction...</h1>
</div>